

import React from 'react'

function ChevronRight() {
  return (
    <>
    <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="24" height="24" fill="none"/>
            <path d="M9.5 7L14.5 12L9.5 17" stroke="#fff" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
    </>
  )
}

export default ChevronRight
